import { Route, Switch } from "react-router-dom";
import UnidadesUnificadasListagemPage from "./Listagem";

function UnidadesUnificadasPages() {
  return (
    <Switch>
      <Route
        exact
        path="/cadastros/unidades-unificadas"
        component={UnidadesUnificadasListagemPage}
      />
    </Switch>
  );
}

export default UnidadesUnificadasPages;
